module.exports = __webpack_public_path__ + "assets/img/middle2.e84a776d.png";